import { render, staticRenderFns } from "./CreateProductForm.vue?vue&type=template&id=30174b70"
import script from "./CreateProductForm.vue?vue&type=script&lang=js"
export * from "./CreateProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports